import { ValidateProperty } from "../../../models/utilities/validate-property";
import { ContainerPaymentType, ContainerSize, ShipmentType } from "../enums/_index";
import { ShipmentCreate } from "../shipments/shipment-create";

export class ContainerCreate extends ShipmentCreate {

    public number : string = '';

    @ValidateProperty({ required: true })
    public carrierId : number | undefined = undefined;

    @ValidateProperty({ required: true })
    public size : ContainerSize | undefined = undefined;
    
    @ValidateProperty({ required: true })
    public paymentType : ContainerPaymentType | undefined = undefined;

    constructor() {
        super();
        this.type = ShipmentType.Container;
    }

}
